module.exports = __webpack_public_path__ + "img/5.d7b5db26.jpg";